import React, { useEffect, useState, useRef } from 'react';
import { AppstoreOutlined, MailOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Outlet, Link, useSearchParams, useNavigate } from "react-router-dom";
import { Typography, Card, Input, DatePicker, Modal, Button, Menu, Col, Row, message, Space, Checkbox, Tab } from "antd";
import axios from 'axios';
import JoditEditor from "jodit-react";
const { Title } = Typography;
const Maintain = () => {
    const editor = useRef(null);
    const [content, setContent] = useState('');
    const [contact_content, set_contact_content] = useState('')
    const [messageApi, contextHolder] = message.useMessage();
    const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        uploader: {
            insertImageAsBase64URI: true,
            // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        },
        language: 'zh_tw'
    };
    const get_header = () => {
        axios
            .get('/cramSchool/api/blog/header/lastest', { params: { "blog_type_id": 9, "blog_id": 103 } })
            .then((response) => {
                setContent(response.data.data[0].content);
            })
    }
    const get_contact_header = () => {
        axios
            .get('/cramSchool/api/blog/contact_us', { params: { "blog_type_id": 10, "blog_id": 116 } })
            .then((response) => {
                set_contact_content(response.data.data[0].content);
            })
    }
    useEffect(() => {
        get_header();
        get_contact_header();
    }, [])
    const handleUpdate = () => {
        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/header/lastest`, [{
                "title": 'lastest_header',
                "content": content,
                "blog_type_id": 9,
                "annoucement_time": time,
                "blog_id": 103

            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                } else {
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                }
                get_header();

            })
    }
    const handleContactUpdate = () => {
        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/contact_us`, [{
                "title": '聯繫我們',
                "content": contact_content,
                "blog_type_id": 10,
                "annoucement_time": time,
                "blog_id": 116

            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                } else {
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                }
                get_contact_header();
            })
    }
    return (
        <>
            {contextHolder}
            <Row gutter={[8, 10]} style={{ paddingTop: '10px' }}>

                <Col span={12}>
                    <Col span={24}>
                        <Title level={3}>形象介紹</Title>
                    </Col>
                    <Col span={24}
                        style={{
                            width: '100%',
                            minHeight: '32rem',
                            maxHeight: '32rem',
                            overflowY: 'scroll'
                        }}>
                        <JoditEditor
                            ref={editor}
                            value={content}
                            config={config}
                            tabIndex={1} // tabIndex of textarea
                            onBlur={content => setContent(content)} // preferred to use only this option to update the content for performance reasons
                            height={500}
                            allowResizeX={true}
                            allowResizeY={true}
                        />
                    </Col>
                    <Col span={24} style={{ paddingTop: '10px' }}>
                        <Row gutter={[10, 10]} justify={"center"}>
                            <Col >
                                <Button size='large'
                                    onClick={e => handleUpdate()}
                                    style={{ background: `#f09a45`, color: '#ffffff' }} block>更新</Button>
                            </Col>
                        </Row>
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={24}>
                        <Title level={3}>畫面預覽</Title>
                    </Col>
                    <Col span={24}>
                        <Card
                            style={{
                                width: '100%',
                                minHeight: '32rem',
                                maxHeight: '32rem',
                                overflowY: 'scroll'
                            }}
                        >
                            <span dangerouslySetInnerHTML={{ __html: content }}></span>
                        </Card>
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={24}>
                        <Title level={3}>聯絡資訊介紹</Title>
                    </Col>
                    <Col span={24}
                        style={{
                            width: '100%',
                            minHeight: '32rem',
                            maxHeight: '32rem',
                            overflowY: 'scroll'
                        }}>
                        <JoditEditor
                            ref={editor}
                            value={contact_content}
                            config={config}
                            tabIndex={1} // tabIndex of textarea
                            onBlur={contact_content => set_contact_content(contact_content)} // preferred to use only this option to update the content for performance reasons
                            height={500}
                            allowResizeX={true}
                            allowResizeY={true}
                        />
                    </Col>
                    <Col span={24}>
                        <Row gutter={[10, 10]} justify={"center"}>
                            <Col >
                                <Button size='large'
                                    onClick={e => handleContactUpdate()}
                                    style={{ background: `#f09a45`, color: '#ffffff' }} block>更新</Button>
                            </Col>
                        </Row>
                    </Col>
                </Col>
                <Col span={12}>
                    <Col span={24}>
                        <Title level={3}>畫面預覽</Title>
                    </Col>
                    <Col span={24}>
                        <Card
                            style={{
                                width: '100%',
                                minHeight: '32rem',
                                maxHeight: '32rem',
                                overflowY: 'scroll'
                            }}
                        >
                            <span dangerouslySetInnerHTML={{ __html: contact_content }}></span>
                        </Card>
                    </Col>
                </Col>

            </Row>
        </>
    )
}
export default Maintain;